import axios from "axios";

const actions = {
  // - toggle snackbar with message
  toggleSnackBar(context, payload) {
    context.commit("mutationSnackBar", payload);
  },

  toggleModal(context, payload) {
    context.commit("mutationModal", payload);
  },

  // - toggle error dialog (for public pages like login)
  toggleErrorDialog(context, payload) {
    context.commit("mutationErrorDialog", {
      show: true,
      message: payload.message || "Terjadi kesalahan. Silakan coba lagi.",
    });
  },

  closeErrorDialog(context) {
    // Only set show to false, keep message unchanged to prevent flicker during close animation
    context.commit("mutationErrorDialog", {
      ...context.state.errorDialog,
      show: false,
    });
  },

  setPageInfo(context, payload) {
    context.commit("mutationPageInfo", payload);
  },

  setProfileMenu(context, payload) {
    context.commit("mutationProfileMenu", payload);
  },

  // vuex of chosenFilter in itemListing
  setItemListingOrganisation(context, payload) {
    context.commit("mutationItemListingOrganisation", payload);
  },

  triggerRouteViewKey(context, payload) {
    context.commit("mutationRouteViewKey", payload);
  },

  setPageLoadingFirstTime(context, payload) {
    context.commit("mutationPageLoadingFirstTime", payload);
  },

  setRouteOnChanged(context, payload) {
    context.commit("mutationRouteOnChanged", payload);
  },

  // Presign upload file USER SERVICE
  async getPresignUrl(_context, payload) {
    try {
      const response = await this.$api.call("shared.getPresignUrl", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async hitPresignUrl(context, { buffer, url }) {
    try {
      const response = await axios.put(url, buffer, {
        onUploadProgress: (progressEvent) => {
          const progress = (progressEvent.loaded / progressEvent.total) * 100;
          context.commit(
            "mutationUploadProgress",
            parseInt(Math.round(progress), 10),
          );
        },
      });
      const responseData = response.data;

      // reset uploadProgress to 0 (init state)
      context.commit("mutationUploadProgress", 0);
      return responseData;
    } catch (error) {
      // reset uploadProgress to 0 (init state)
      context.commit("mutationUploadProgress", 0);

      throw error;
    }
  },
};

export default actions;
